import { useMemo } from 'react';
import { Navigate, generatePath, useSearchParams } from 'react-router-dom';

import { AccessRequestsScopeModel, AccessStatus, useListAccessRequests } from '@apono/client-app-sdk';
import routes from '@routes';

import { Loader } from '@common/ui/Loader';
import { SUBMITTED_QUERY_PARAM } from './OnboardingAccessRequestFormPage';

export default function OnboardingAccessRequestFetchingPage() {
  const [searchParams] = useSearchParams();

  const { data, isFetched } = useListAccessRequests({
    statuses: [
      AccessStatus.Pending,
      AccessStatus.Granting,
      AccessStatus.Active,
      AccessStatus.Revoking,
      AccessStatus.PENDING,
      AccessStatus.APPROVED,
      AccessStatus.GRANTED,
      AccessStatus.REVOKING,
    ],
    scope: AccessRequestsScopeModel.MyRequests,
  });

  const accessRequestId = useMemo(() => {
    if (!data?.pages || data.pages.length === 0 || data.pages[0].data.length === 0) return;
    return data.pages[0].data[0].id;
  }, [data]);

  if (!isFetched || (searchParams.has(SUBMITTED_QUERY_PARAM) && !accessRequestId)) {
    return <Loader />;
  }

  if (!accessRequestId) {
    return <Navigate to={generatePath(routes.OnboardingIntegrationRequest.path)} />;
  }

  // TODO: Very hacky. We should have a better way to handle this.
  return <Navigate to={generatePath(routes.OnboardingAccessRequest.path, { id: accessRequestId })} />;
}
